import React, { useEffect, useState } from 'react'
import style from './signup.module.css'
import logo from '../../../assets/images/Astro-03.png';
import illustration1 from '../../../assets/images/illustrations-01.svg'
import illustration2 from '../../../assets/images/illustrations-02.svg'
import illustration3 from '../../../assets/images/illustrations-03.svg'
import illustration4 from '../../../assets/images/illustrations-04.svg'




const images = [illustration1, illustration2, illustration3, illustration4];

const slideContent = [
    {
        title: "Buy & Swap Crypto",
        description: "Buy crypto with Naira or Cedis, swap instantly, or place limit orders."
    },
    {
        title: "Virtual Cards",
        description: "Create virtual cards for secure global payments."
    },
    {
        title: "Bank Account",
        description: "Get a free Bank account to send and receive money instantly."
    },
    {
        title: "Gift Cards",
        description: "Convert gift cards to cash instantly."
    }
];

const ImageComp = () => {

    const [count, setCount] = useState(1);
    const [image, setImage] = useState(images[count - 1])
    
    const handleCounter = () => {
        if (count < 4) { 
            setTimeout(() => {
                setCount(count + 1)
            }, 5000)
        } else {
            setTimeout(() => {
                setCount(1)
            }, 5000)
        }

        setImage(images[count - 1])
    }

    useEffect(() => { 
        handleCounter()
    }, [count])

  return (
    <div className={style.left} >
        <div className={style.logo} style={{zIndex:2000}} >
            <img src={logo} alt="astroafrica.site/logo.svg" />
        </div>
        <div className={style.contImg} >
            <div className={style.img} >
                <img src={image} alt="astroafrica.site/astro1.svg" />
            </div>
            <div className={style.cont} >
                <h2>{slideContent[count - 1].title}</h2>
                <p>{slideContent[count - 1].description}</p>
                
                {/* these are the dots indicating the picture on display. */}
                <div className={style.slideCators} >
                      <div style={{
                          width: count === 1 ? "24px" : "6px",
                          background: count === 1 ? "#40196D" : "#EAE9ED"
                    }} className={style.dotActive} ></div>
                      <div
                        style={{
                          width: count === 2 ? "24px" : "6px",
                          background: count === 2 ? "#40196D" : "#EAE9ED"
                        }}
                          className={style.dot} ></div>
                      <div
                        style={{
                          width: count === 3 ? "24px" : "6px",
                          background: count === 3 ? "#40196D" : "#EAE9ED"
                        }}
                          className={style.dot} ></div>
                      <div
                        style={{
                          width: count === 4 ? "24px" : "6px",
                          background: count === 4 ? "#40196D" : "#EAE9ED"
                        }}
                          className={style.dot} ></div>
                </div>
            </div>
      </div>
    </div>
  )
}

export default ImageComp